import { ILeftVsRightKeys, ITournamentMatchShotData } from 'twain-sport-fe-mono/interfaces';

interface IShotData {
    leftShorts: ITournamentMatchShotData[];
    rightShorts: ITournamentMatchShotData[];
    timeAfterStart: number;
    pointsDiff: number;
    isLeaderChanged: boolean;
    newLeader: ILeftVsRightKeys;
}

export const getInPlayAudio = (
    data: IShotData,
    shotsPlayedSounds: string[],
    leader: ILeftVsRightKeys,
    timeLeftFn: (time: number) => number,
): string => {
    if (!data.leftShorts.length || !data.rightShorts.length) {
        return null;
    }

    const list: Record<string, boolean> = {
        'inPlayGame.1': data.pointsDiff > 7,
        'inPlayGame.2': data.pointsDiff > 10,
        'inPlayGame.3': data.timeAfterStart >= 20 && data.pointsDiff <= 3,
        'inPlayGame.4': data.timeAfterStart >= 15 && data.pointsDiff <= 3,
        'inPlayGame.5':
            data.timeAfterStart >= 15 &&
            data.pointsDiff === 0 &&
            data.leftShorts.length === data.rightShorts.length,
        'inPlayGame.6':
            data.timeAfterStart >= 10 &&
            data.pointsDiff === 0 &&
            data.leftShorts.length === data.rightShorts.length,
        'inPlayGame.7': data.timeAfterStart >= 20 && data.isLeaderChanged && leader === 'left',
        'inPlayGame.8': data.timeAfterStart >= 20 && data.isLeaderChanged && leader === 'right',
        'inPlayGame.9':
            data.timeAfterStart >= 50 && data.timeAfterStart <= 60 && data.pointsDiff >= 7,
        'inPlayGame.10':
            data.timeAfterStart >= 55 &&
            data.timeAfterStart <= 60 &&
            (data.pointsDiff === 1 || data.pointsDiff === 2),

        'inPlayBad.1':
            data.leftShorts.length === 3 && !data.leftShorts.some((item) => item?.isSuccessful),
        'inPlayBad.2':
            data.timeAfterStart >= 35 &&
            data.leftShorts.length > 5 &&
            !data.leftShorts.slice(-3).some((item) => item?.isSuccessful),
        'inPlayBad.3':
            data.timeAfterStart >= 45 &&
            data.leftShorts.length > 5 &&
            data.leftShorts.filter((item) => timeLeftFn(item?.time) > 40 && !item?.isSuccessful)
                .length >= 3,
        'inPlayBad.5':
            data.rightShorts.length === 3 && !data.rightShorts.some((item) => item?.isSuccessful),
        'inPlayBad.6':
            data.timeAfterStart >= 35 &&
            data.rightShorts.length > 5 &&
            !data.rightShorts.slice(-3).some((item) => item?.isSuccessful),
        'inPlayBad.7':
            data.timeAfterStart >= 45 &&
            data.rightShorts.length > 5 &&
            data.rightShorts.filter((item) => timeLeftFn(item?.time) > 40 && !item?.isSuccessful)
                .length >= 3,
    };

    const audios = Object.entries(list).reduce((acc, [key, value]) => {
        if (value && !shotsPlayedSounds.includes(key)) {
            acc.push(key);
        }

        return acc;
    }, []);

    return audios.length ? audios[Math.floor(Math.random() * audios.length)] : null;
};
